import { Routes } from '@angular/router';
import { InicioComponent } from './web/inicio/inicio.component';
// import { BookingWidgetComponent } from './components/karve/booking-widget/booking-widget.component';
// import { authGuard } from './auth.guard';
import { Error404Component } from './web/error404/error404.component';
import { LanguageGuard } from './guard/language.guard';
// import { DevelopmentComponent } from './web/development/development.component';

// interface routeStructureInterface {
//   home: string[];
//   product: string[];
//   // productDetail: string[];
//   privacy: string[];
//   terms: string[];
//   legal: string[];
//   team: string[];
//   contact: string[];
//   order: string[];
//   booking: string[];
//   news: string[];
//   accident: string[];
//   cancellationPolicy: string[];
//   renovationDivingCenter: string[];
//   renovationProDiver: string[];
//   accesibility: string[];
//   [key:string]: string;
// }

export const routeStructure: { [key: string]: string[] } = {
  home: ['inicio', 'home'],
  // vans: ['furgonetas', 'vans'],
  // rent: ['alquiler', 'rent'],
  product: ['dive-insurance', 'seguro-buceo'],
  privacy: ['privacidad', 'privacy'],
  terms: ['terminos', 'terms'],
  legal: ['aviso-legal', 'legal-warning'],
  team: ['nuestro-equipo', 'our-team'],
  accident: ['caso-accidente', 'accident-case'],
  contact: ['contacto', 'contact', 'kontakt'],
  order: ['order', 'pedido'],
  news: ['noticias', 'news'],
  booking: ['booking', 'reserva'],
  cancellationPolicy: ['cancellation-policy', 'politica-cancelacion'],
  renovationDivingCenter: [
    'diving-center-renovation',
    'renovacion-centros-buceo',
  ],
  renovationProDiver: ['pro-diver-renovation', 'renovacion-buceo-profesional'],
  accesibility: ['accesibility', 'accesibilidad'],
};

export const routes: Routes = [
  {
    path: '',
    canActivate: [LanguageGuard],
    component: InicioComponent,
    pathMatch: 'full',
  },
  ...routeStructure['home'].map(path => ({
    path,
    canActivate: [LanguageGuard],
    component: InicioComponent,
  })),
  {
    path: 'login',
    loadChildren: () => import('@ls-commons/login').then(r => r.loginRoutes),
    data: {
      title: $localize`:@@login.title:Iniciar Sesión`,
      loginGoogle: false,
      linkBack: '/login',
    },
  },
  {
    path: 'redsys-notify/:status_code',
    // title: $localize`:@@title.dashboard:Panel`,
    loadComponent: () =>
      import('./web/redsys-notify/redsys-notify.component').then(
        r => r.RedsysNotifyComponent
      ),
  },
  {
    path: 'dashboard',
    // title: $localize`:@@title.dashboard:Panel`,
    loadChildren: () =>
      import('./dashboard/dashboard.routes').then(r => r.dashboardRoutes),
  },

  ...routeStructure['product'].map(path => ({
    path,
    canActivate: [LanguageGuard],
    loadChildren: () =>
      import('./web/dive-insurance/dive-insurance.routes').then(
        r => r.diveInsuranceRoutes
      ),
  })),

  {
    path: 'scubamedic',
    loadComponent: () =>
      import('./web/scubamedic/scubamedic.component').then(
        r => r.ScubamedicComponent
      ),
  },

  {
    path: 'dive-pro',
    loadComponent: () =>
      import('./web/dive-pro/dive-pro.component').then(r => r.DiveProComponent),
  },

  ...routeStructure['legal'].map(path => ({
    path,
    loadComponent: () =>
      import('./web/aviso-legal/aviso-legal.component').then(
        r => r.AvisoLegalComponent
      ),
  })),

  ...routeStructure['team'].map(path => ({
    path,
    canActivate: [LanguageGuard],
    loadComponent: () =>
      import('./web/section-team/section-team.component').then(
        r => r.SectionTeamComponent
      ),
  })),
  ...routeStructure['contact'].map(path => ({
    path,
    loadComponent: () =>
      import('./web/contacto/contacto.component').then(
        r => r.ContactoComponent
      ),
  })),

  ...routeStructure['renovationDivingCenter'].map(path => ({
    path,
    canActivate: [LanguageGuard],
    loadComponent: () =>
      import(
        './web/renovation/renovation-diving-center/renovation-diving-center.component'
      ).then(r => r.RenovationDivingCenterComponent),
  })),

  ...routeStructure['renovationProDiver'].map(path => ({
    path,
    canActivate: [LanguageGuard],
    loadComponent: () =>
      import(
        './web/renovation/renovation-pro-diver/renovation-pro-diver.component'
      ).then(r => r.RenovationProDiverComponent),
  })),

  // ...routeStructure.order.map(path => ({
  //   path,
  //   loadComponent: () =>
  //     import('./web/order/order/order.component').then(r => r.OrderComponent),
  // })),
  // ...routeStructure.booking.map(path => ({
  //   path,
  //   loadComponent: () =>
  //     import('./web/booking/booking.component').then(r => r.BookingComponent),
  // })),
  {
    path: 'faq',
    canActivate: [LanguageGuard],
    loadComponent: () =>
      import('./web/faq/faq.component').then(r => r.FaqComponent),
  },
  {
    path: 'cookies',
    loadComponent: () =>
      import('./web/cookies/cookies.component').then(r => r.CookiesComponent),
  },
  ...routeStructure['cancellationPolicy'].map(path => ({
    path,
    loadComponent: () =>
      import('./web/cancellation-policy/cancellation-policy.component').then(
        r => r.CancellationPolicyComponent
      ),
  })),
  ...routeStructure['accesibility'].map(path => ({
    path,
    loadComponent: () =>
      import('./web/accesibilidad/accesibilidad.component').then(
        r => r.AccesibilidadComponent
      ),
  })),
  ...routeStructure['news'].map(path => ({
    path,
    canActivate: [LanguageGuard],
    loadComponent: () =>
      import('./web/noticias/noticias.component').then(
        r => r.NoticiasComponent
      ),
  })),
  ...routeStructure['accident'].map(path => ({
    path,
    loadComponent: () =>
      import(
        './web/accident-case/caso-accidente/caso-accidente.component'
      ).then(r => r.CasoAccidenteComponent),
  })),
  // --------------------------------------------------------------------------

  { path: '**', component: Error404Component },
];
